<ng-container *transloco="let t; read: 'functions'">
  <section class="teaser">
    <div class="teaser-pics">
      <div
        class="teaser teaser1 active"
        [ngStyle]="{ backgroundImage: images[0] }"
      ></div>
    </div>
    <div class="content">
      <div class="title">{{ t("title") }}</div>
    </div>
  </section>
  <section class="article">
    <article>
      <h2>{{ t("still-image-title") }}</h2>
      <div class="text" [innerHTML]="t('still-image-content')"></div>
      <a class="call" (click)="openModal('video1')">{{ t("show-video") }}</a>
    </article>
    <hr />

    <article>
      <h2>{{ t("snapshot-title") }}</h2>
      <div class="text" [innerHTML]="t('snapshot-content')"></div>
      <a class="call" (click)="openModal('video2')">{{ t("show-video") }}</a>
    </article>
    <hr />

    <article>
      <h2>{{ t("import-folder-title") }}</h2>
      <div class="text" [innerHTML]="t('import-folder-content')"></div>
      <a class="call" (click)="openModal('video3')">{{ t("show-video") }}</a>
    </article>
    <hr />

    <article>
      <h2>{{ t("undo-title") }}</h2>
      <div class="text" [innerHTML]="t('undo-content')"></div>
      <a class="call" (click)="openModal('video4')">{{ t("show-video") }}</a>
    </article>
  </section>
  <hr />
  <section class="blocks">
    <h2 [innerHTML]="t('latest-functions-title')"></h2>
    <div class="blocks">
      <article>
        <div><img src="assets/meta-daten_icon.png" /></div>
        <h3 class="sub">{{ t("meta-title") }}</h3>
        <div>{{ t("meta-text") }}</div>
      </article>
      <article>
        <div><img src="assets/archivierung_icon.png" /></div>
        <h3 class="sub">{{ t("archive-title") }}</h3>
        <div>{{ t("archive-text") }}</div>
      </article>
      <article>
        <div><img src="assets/responsivitaet_icon.png" /></div>
        <h3 class="sub">{{ t("responsive-title") }}</h3>
        <div>{{ t("responsive-text") }}</div>
      </article>
    </div>
    <div class="center">
      <a class="call" [routerLink]="['/function-archive']">{{
        t("function-history-button")
      }}</a>
    </div>
  </section>

  <v2m-modal id="video1">
    <h3>{{ t("still-image-title") }}</h3>
    <div class="player">
      <video
        controls
        src="https://www.video2manual.de/videos/bilder-einlesen.mp4"
      ></video>
      <button class="close" (click)="closeModal('video1')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </v2m-modal>
  <v2m-modal id="video2">
    <h3>{{ t("snapshot-title") }}</h3>
    <div class="player">
      <video
        controls
        src="https://www.video2manual.de/videos/schnappschuss.mp4"
      ></video>
      <button class="close" (click)="closeModal('video2')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </v2m-modal>
  <v2m-modal id="video3">
    <h3>{{ t("import-folder-title") }}</h3>
    <div class="player">
      <video
        controls
        src="https://www.video2manual.de/videos/verzeichnisse-importieren.mp4"
      ></video>
      <button class="close" (click)="closeModal('video3')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </v2m-modal>
  <v2m-modal id="video4">
    <h3>{{ t("undo-title") }}</h3>
    <div class="player">
      <video
        controls
        src="https://www.video2manual.de/videos/rueckgaengig.mp4"
      ></video>
      <button class="close" (click)="closeModal('video4')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </v2m-modal>
</ng-container>
